import { useQuery } from "react-query";
import { getNotifyContact } from "../../../queries/notify";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";

export function useNotifyContact({ id }: { id?: number | null }) {
  const networkHeaders = useNetworkHeaders();

  const { data: notifyContact, isLoading: isNotifyContactLoading } = useQuery(
    buildNotifyContactQueryKey({ id }),
    getNotifyContact(networkHeaders),
    {
      queryFnParamsFilter(args) {
        return [args[1]];
      },
      enabled: !!id,
    },
  );

  return {
    notifyContact,
    isNotifyContactLoading,
  };
}

export function buildNotifyContactQueryKey(params: { id?: number | null }) {
  return ["notifyContact", params];
}
